import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import 'src/resources/fontawesome/css/all.min.css';
import 'src/App.css';
import AppWrapper from './app/AppWrapper';
import { BrowserRouter } from 'react-router-dom';
import { EnvironmentProvider } from './providers/environment/EnvironmentProvider.tsx';
import { SessionProvider } from './providers/session/SessionProvider.tsx';
import { SystemProvider } from './providers/system/SystemProvider.tsx';
import { Provider } from 'react-redux';
import { store } from './app/store.ts';
import ScrollToTop from './ui/ScrollToTop.tsx';
import OnlineCheck from './ui/onlineCheck.tsx';
import ActivityDetector from './ui/activity-detector/ActivityDetector.tsx';
import ScreenSizeObserver from './ui/screen-size-observer/ScreenSizeObserver.tsx';

const root = createRoot(document.getElementById('root')!);

root.render(
  <BrowserRouter>
    <EnvironmentProvider>
      <SessionProvider>
        <SystemProvider>
          <Provider store={store}>
            <ScrollToTop />
            <OnlineCheck />
            <ActivityDetector />
            <ScreenSizeObserver />
            <AppWrapper />
          </Provider>
        </SystemProvider>
      </SessionProvider>
    </EnvironmentProvider>
  </BrowserRouter>,
);

// The pre-React boot loader (#pre-react-loader) is removed by FullScreenLoader
// when it mounts — that way the overlay stays visible until React has actually
// rendered the loading state, with no gap between the two loaders.
